module.exports = __webpack_public_path__ + "img/大昌树脂.28ca382b.png";